/* Koreachi | hotspots.js — ingredient hotspot cards (no library) */
(function () {
  'use strict';
  document.querySelectorAll('[data-hotspots]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-hotspot]');

    function closeAll(except) {
      buttons.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var card = document.getElementById(b.getAttribute('aria-controls'));
        if (card) card.hidden = true;
      });
    }

    buttons.forEach(function (btn) {
      var card = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (card) card.hidden = open;
      });
    });

    document.addEventListener('click', function (e) {
      if (!group.contains(e.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  });
})();
